<template>
    <a :href="data.url" class="wb-box">
        <div class="wb-box__img">
            <Image :image="data.image" :isLazy="false" :width="373" :height="210"></Image>
        </div>

        <div class="wb-box__text">
            <h4 class="wb-box__title">{{ data.title }}</h4>
            <p class="wb-box__lead" v-html="data.lead"></p>
        </div>
    </a>
</template>

<script>
import Image from "../elements/Image.vue";

export default {
    name: "WbBox",
    components: {
        Image,
    },
    props: {
        index: {
            type: Number
        },
        data: {
            type: Object
        }
    },
    computed: {

    },
    methods: {

    }
};
</script>
